module.exports = __webpack_public_path__ + "target-icon.09730ffd6014c76af4cd.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/assets/target-icon.png
// module id = ../../../../../src/assets/target-icon.png
// module chunks = main